<template>
  <div>
    <div class="payment-summary" :class="customClass">
      <div class="summary-toggler" @click="active = !active">
        <h3>{{ formTitle }}</h3>
        <div class="summary-details">
          <label class="title">
            <template v-if="priceTitle">{{ priceTitle }}: ${{calcTotal}}</template>
            <template v-else>${{calcTotal}}</template>
            <svg xmlns="http://www.w3.org/2000/svg" width="44" height="44" viewBox="0 0 24 24"
              stroke-width="1.5" stroke="#125ea2" fill="none" stroke-linecap="round" stroke-linejoin="round"
              class="icon icon-tabler icon-tabler-chevron-down">
              <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
              <polyline points="6 9 12 15 18 9"></polyline>
            </svg>
          </label>
            <ul>
              <li v-for="product in products" :key="product['product-code']">
                <label>{{ product['product-description'] }}</label>
                <span>${{ product['total-price'] }}</span>
              </li>
              <li v-if="donationPrice > 0">
                <label>Donation</label>
                <span>${{donationPrice}} </span>
              </li>
            </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    formTitle: String,
    priceTitle: { type: String, default: 'Total' },
    products: { type: Array, required: true },
    donationPrice: { type: Number, default: 0 },
  },
  data() {
    return {
      active: false
    }
  },
  computed: {
    calcTotal() {
      const price = []
      let donationPrice = this.donationPrice ? this.donationPrice : 0
      this.products.forEach(product => {
        price.push(product['total-price'])
      })

      const total = price.reduce((a,b) => {
        if(a !== undefined && b !== undefined) {
          return parseInt(a) + parseInt(b)
        }
      }, 0)

      let totalPrice = total + donationPrice
      this.$emit('totalPrice', totalPrice);
      return totalPrice;
    },
    customClass() {
      return {
        'active': this.active
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.payment-summary {
  width: 100%;

  .summary-toggler {
    padding: 20px 30px 0 30px;
    cursor: pointer;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    background-color: #fbfbfc;
    border-bottom: 1px solid #f2f4f5;

    @media screen and (max-width: 767px) {
      flex-direction: column;
      align-items: stretch;
    }

    h3 {
      font-weight: 100;
      font-size: 1.2rem;
      margin: 0;

      @media screen and (max-width: 767px) {
        font-size:1rem;
        font-weight: 600;
        margin-bottom: 15px;
      }
    }

    .summary-details {
      label.title {
        display: flex;
        align-items: center;
        justify-content: flex-end;

        color:#00529b!important;
        font-weight: bold;

        @media screen and (max-width: 767px) {
          font-size:1rem;
        }

        svg {
          width: 30px;
          height: 30px;
          background: #f2f4f5;
          padding: 8px;
          margin-left: 10px;
          border-radius: 100%;
          transition: all .3s cubic-bezier(.48,.33,.37,.77);
        }
      }

      ul {
        overflow: hidden;
        max-height: 0;
        padding-left: 0;
        transition: all .3s cubic-bezier(.48,.33,.37,.77);

        li {
          list-style-type: none;
          display: flex;
          place-content: flex-end;

          label {
            margin-right: 20px;
            font-weight: 100;
          }

          @media screen and (max-width: 767px) {
            label {
              margin-right: 7px;
              font-size: 0.9rem;
            }

            span {
              font-size: 0.9rem;
            }
          }
        }
      }
    }
  }

  &.active {
    .title svg {
      transform: rotate(180deg);
    }

    .summary-details {
      ul {
        max-height: 165px;
      }
    }
  }
}
</style>
